'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createPreset", {
    enumerable: true,
    get: function() {
        return createPreset;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _react1 = require("@griffel/react");
const _Text = require("../Text");
function createPreset(options) {
    const { useStyles, className, displayName } = options;
    const Wrapper = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
        'use no memo';
        const styles = useStyles();
        const state = (0, _Text.useText_unstable)(props, ref);
        (0, _Text.useTextStyles_unstable)(state);
        state.root.className = (0, _react1.mergeClasses)(className, state.root.className, styles.root, props.className);
        return (0, _Text.renderText_unstable)(state);
    });
    Wrapper.displayName = displayName;
    return Wrapper;
}
